import React, { useCallback, useMemo } from 'react';
import cx from 'classnames';
import Checkbox from 'js/components/Forms/Checkbox';
import CohortMember from './CohortMember';
import { useSelectedMemberContext } from 'js/routes/UserGroups/SelectedMemberContext';

import styles from './CohortList.module.scss';

function Cohort({ cohort }) {
  const { isSelected, selectAll } = useSelectedMemberContext();

  const rawCohortState = useMemo(() => {
    return cohort.members.reduce(
      (acc, member, i, arr) => {
        const isChecked = isSelected(member.user_group_member.id);
        return {
          checked: acc.checked || isChecked,
          allChecked: acc.allChecked && isChecked,
        };
      },
      {
        checked: false,
        allChecked: true,
      }
    );
  }, [cohort.members, isSelected]);

  const cohortState = useMemo(() => {
    return {
      checked: rawCohortState.checked,
      indeterminate: rawCohortState.checked && !rawCohortState.allChecked,
    };
  }, [rawCohortState.checked, rawCohortState.allChecked]);

  const handleCheckboxChange = useCallback(() => {
    // I'm not reliably getting the indeterminate state from the checkbox,
    // so I'm using my own state to determine if the checkbox should be indeterminate
    const check = cohortState.indeterminate || !cohortState.checked;
    const memberIds = cohort.members.map(
      (member) => member.user_group_member.id
    );
    selectAll(memberIds, check);
  }, [
    selectAll,
    cohort.members,
    cohortState.indeterminate,
    cohortState.checked,
  ]);

  return (
    <div key={cohort.cohort} className={styles.cohort}>
      <div className={cx(cohort.className, styles['cohort-name'])}>
        <Checkbox
          checked={cohortState.checked}
          indeterminate={cohortState.indeterminate}
          onChange={handleCheckboxChange}
        >
          {cohort.cohort ?? 'Unassigned'}
        </Checkbox>
      </div>
      <div className={styles['cohort-members']}>
        {cohort.members.map((member) => (
          <CohortMember key={member.user_group_member.id} member={member} />
        ))}
      </div>
    </div>
  );
}

export default Cohort;
